(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["lenora-volume-calc"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-lh-calc]').forEach(function (calc) {
    var variants = JSON.parse(calc.querySelector('[data-lh-variants]').textContent);
    var tiers = JSON.parse(calc.dataset.tiers);
    var fmt = calc.dataset.moneyFormat || '€{{amount_with_comma_separator}}';
    var chipsWanted = (calc.dataset.chips || '').split(',').map(function (s) { return parseInt(s, 10); }).filter(Boolean);
    var units = calc.querySelector('[data-lh-units]'), chipsEl = calc.querySelector('[data-lh-chips]'), tiersEl = calc.querySelector('[data-lh-tiers]');
    var hint = calc.querySelector('[data-lh-hint]');
    var t = JSON.parse(calc.dataset.t || '{}');
    function money(cents) {
      var v = (cents / 100).toFixed(2), parts = v.split('.'), intp = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      var out = fmt.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, intp + ',' + parts[1])
                   .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, intp)
                   .replace(/\{\{\s*amount\s*\}\}/, parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1])
                   .replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0]);
      return out.replace(/<[^>]+>/g, '');
    }
    function eur(n) { return String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' €'; }
    function currentVariant() {
      var form = document.querySelector('product-form-component form[action*="/cart/add"]');
      var id = form ? parseInt((form.querySelector('input[name="id"]') || {}).value, 10) : NaN;
      if (isNaN(id)) id = parseInt(calc.dataset.selected, 10);
      return variants.find(function (v) { return v.id === id; }) || variants[0];
    }
    function roundTo(n, pack) { n = Math.max(pack, Math.round(n)); return Math.ceil(n / pack) * pack; }
    function render() {
      var v = currentVariant(); if (!v) return;
      var pack = v.pack || 1;
      var q = roundTo(parseInt(units.value, 10) || pack, pack); units.value = q; units.step = pack; units.min = pack;
      var subtotal = q * v.price;
      var tierIdx = 0; tiers.forEach(function (tier, i) { if (subtotal >= tier.min * 100) tierIdx = i; });
      var pct = tiers[tierIdx].pct, discount = Math.round(subtotal * pct / 100), total = subtotal - discount;
      calc.querySelector('[data-lh-line-label]').textContent = q + ' ' + t.units + ' × ' + money(v.price);
      calc.querySelector('[data-lh-subtotal]').textContent = money(subtotal);
      calc.querySelector('[data-lh-pct]').textContent = pct + '%';
      calc.querySelector('[data-lh-discount]').textContent = '−' + money(discount);
      calc.querySelector('[data-lh-total]').textContent = money(total);
      calc.querySelector('[data-lh-net]').textContent = money(Math.round(total / q)) + ' / ' + t.unitsShort;
      tiersEl.innerHTML = tiers.map(function (tier, i) {
        var label = i === 0 ? t.tierLess.replace('{n}', eur(tiers[1].min)) : t.tierFrom.replace('{n}', eur(tier.min));
        return '<div class="lh-calc__tier' + (i === tierIdx ? ' is-active' : (i < tierIdx ? ' is-passed' : '')) + '"><b>' + tier.pct + '%</b>' + label + '</div>';
      }).join('');
      chipsEl.innerHTML = chipsWanted.map(function (c) { var cq = roundTo(c, pack); return '<button type="button" class="lh-calc__chip' + (cq === q ? ' is-active' : '') + '" data-q="' + cq + '">' + cq + ' ' + t.unitsShort + '</button>'; }).join('');
      chipsEl.querySelectorAll('[data-q]').forEach(function (btn) { btn.addEventListener('click', function () { units.value = btn.dataset.q; render(); }); });
      if (tierIdx < tiers.length - 1) {
        var next = tiers[tierIdx + 1], need = Math.ceil((next.min * 100 - subtotal) / v.price); need = Math.ceil(need / pack) * pack;
        hint.textContent = t.hintMore.replace('{u}', need).replace('{e}', money(need * v.price)).replace('{p}', next.pct);
      } else { hint.textContent = t.hintMax; }
      calc.querySelector('[data-lh-add]').textContent = t.addLabel.replace('{n}', q) + ' ' + money(total);
    }
    calc.querySelector('[data-lh-minus]').addEventListener('click', function () { var v = currentVariant(); units.value = Math.max(v.pack, (parseInt(units.value, 10) || 0) - v.pack); render(); });
    calc.querySelector('[data-lh-plus]').addEventListener('click', function () { var v = currentVariant(); units.value = (parseInt(units.value, 10) || 0) + v.pack; render(); });
    units.addEventListener('change', render);
    calc.querySelector('[data-lh-add]').addEventListener('click', function () {
      var form = document.querySelector('product-form-component form[action*="/cart/add"]'); if (!form) return;
      var qty = form.querySelector('input[name="quantity"]');
      if (qty) { qty.value = units.value; qty.dispatchEvent(new Event('change', { bubbles: true })); }
      if (form.requestSubmit) form.requestSubmit(); else form.submit();
    });
    var idInput = document.querySelector('product-form-component form[action*="/cart/add"] input[name="id"]');
    if (idInput) new MutationObserver(render).observe(idInput, { attributes: true, attributeFilter: ['value'] });
    document.addEventListener('change', function (e) { if (e.target && e.target.closest && e.target.closest('variant-picker, [data-variant-picker], product-form-component')) setTimeout(render, 50); }, true);
    render();
  });
  } catch(e) { console.error(e); }
})();

})();
